@if (show) {
<div class="spinner-container">
  <div class="spinner"></div>
  <ng-content></ng-content>
</div>
}
